<div class="broker-container">

  <div class="calendar-menu">
    <app-menu-calendar
      class="menu"
      [showFilter]="showFilter"
      [isSearch]="isSearch"
      [isAlert]="alertFilter"
      [incrementValue]="activeMonth"
      [decrementValue]="activeMonth"
      [monthInput]="activeMonth"
      [year]="activeYear"
      [showColumnCalendar]="showColumnCalendar"
      (openCalendar)="openCalendar($event)"
      (clickCalendar)="clickCalendar($event)"
      (clickGear)="clickGear($event)"
      (clickBack)="clickBack($event)"
      (clickNext)="clickNext($event)"
      (goTodayDate)="goToday()"
      (selectViewMode)="selectViewMode($event)"
      (openFilter)="getFilter($event)"
      (clearFilter)="clearForm()">
      <app-today-schedule [schedule]="mockTodaySchedule.activities"></app-today-schedule>
    </app-menu-calendar>
    <button class="btn-create" (click)="openModalMark({day: activeDay, month: activeMonth })">Criar</button>
  </div>

  <div class="container">
    <div class="show-calendar" *ngIf="showColumnCalendar">
      <app-calendar
        [calendar]="mockCalendar"
        [activeYear]="activeYear"
        [activeMonth]="activeMonth"
        [activeDay]="activeDay"
        (selectDate)="selectDate($event)"
      ></app-calendar>
      <div class="container-padding">
        <app-today-schedule
          [schedule]="mockTodaySchedule.activities"
        ></app-today-schedule>
      </div>
    </div>
    <div class="calendar-view" [ngClass]="{'full-calendar': !showColumnCalendar}">
      <app-calendar-view
        [calendar]="mockCalendar"
        [viewMode]="calendarViewMode"
        [activeYear]="activeYear"
        [activeMonth]="activeMonth"
        [activeDay]="activeDay"
        (openMark)="openMarkModal($event)"
        (openNewMark)="openNewMarkModal($event)"
      ></app-calendar-view>
    </div>
  </div>

</div>

<app-calendar-mark-modal [markData]="markData" (closeModal)="closeMarkModal()" *ngIf="showMarkModal"></app-calendar-mark-modal>
<app-calendar-mark [open]="openEvent" [requestData]="dataMark" (close)="openEvent = $event" *ngIf="openEvent"></app-calendar-mark>

<app-filter-calendar 
  *ngIf="showFilter" 
  [filterForm]="filterForm" 
  (sendCloseFilter)="getCloseFilter($event)"
  (getFilter)="alertFilter = $event"
  (emitForm)="applyFilter()"
  (emitFilter)="isSearch = $event"
  (resetForm)="clearForm()"
></app-filter-calendar>
